export default function StatsProof() {
  return (
    <section className="py-16 bg-gradient-to-br from-blue-600 to-teal-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Le Marché de la Réparation de Fenêtres
          </h2>
          <p className="text-lg text-blue-100 max-w-3xl mx-auto">
            Un secteur en pleine croissance avec une demande constante
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/20">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-home-4-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-white mb-2">15M+</div>
            <div className="text-blue-100 text-sm font-medium">Logements en France</div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/20">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-tools-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-white mb-2">24h</div>
            <div className="text-blue-100 text-sm font-medium">Délai d'Intervention</div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/20">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-euro-circle-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-white mb-2">350€</div>
            <div className="text-blue-100 text-sm font-medium">Panier Moyen</div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/20">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-line-chart-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-white mb-2">+25%</div>
            <div className="text-blue-100 text-sm font-medium">Croissance Annuelle</div>
          </div>
        </div>
      </div>
    </section>
  );
}
